<template>
  <div class="gpsr-info-view">
    <Spin v-if="pageLoading" fix></Spin>
    <div class="head-btn">
      <span class="text-underline" @click="openTemplateModal" v-if="permission.gpsrTemplate">GPSR填写模板管理</span>
      <span class="text-underline ml20" @click="openEditModal" v-if="permission.editGpsr">编辑GPSR资料</span>
      <span class="text-underline ml20 error" @click="delGpsrInfo" v-if="permission.deleteGpsr && !$common.isEmpty(pageDetails)">删除GPSR资料</span>
    </div>
    <!-- 提示 -->
    <div class="item-details not-gpsr-warning ml20 mt15 mb15">
      <div class="details-item container-full not-vertical-center" v-if="$common.isEmpty(pageDetails)">
        <label class="details-label" style="width: 160px;"><Icon type="md-alert" class="not-gpsr-icon" />无GPSR资料：</label>
        <div class="details-value" style="margin-top: 3px;">
          <p>商品入库时，将打印LAPA小标签入库；</p>
          <p> 商品外包装太小，或某种特殊原因，商品无法贴GPSR标签时，使用“无GPSR资料”；</p>
          <p>商品不会销售往欧洲市场与英国市场时，使用“无GPSR资料；</p>
        </div>
      </div>
      <div class="details-item container-full not-vertical-center" v-else>
        <label class="details-label" style="width: 160px;"><Icon type="md-alert" class="not-gpsr-icon" />有GPSR资料：</label>
        <div class="details-value" style="margin-top: 3px;">
          <p>商品入库时，将打印GPSR标签入库；</p>
        </div>
      </div>
    </div>
    <div v-if="!$common.isEmpty(pageDetails)">
      <div class="content-item content-padding">
        <div class="item-title">
          <div class="title-text">1、产品信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-half">
            <label class="details-label">Product name:</label>
            <div class="details-value">{{ pageDetails.productName || '如不填写，打印标签时，使用：SPU的英文品名'}}</div>
          </div>
          <div class="details-item container-half">
            <label class="details-label">Model:</label>
            <div class="details-value">{{ pageDetails.model || '如不填写，打印标签时，使用：SKU编码'}}</div>
          </div>
          <div class="details-item container-half">
            <label class="details-label">Batch number:</label>
            <div class="details-value">{{ pageDetails.batchNumber || '如不填写，打印标签时，使用：自动按规则生成批次号' }}</div>
          </div>
          <div class="details-item container-half">
            <label class="details-label">Made in:</label>
            <div class="details-value">{{ pageDetails.madeIn || '如不填写，打印标签时，使用：CHINA' }}</div>
          </div>
        </div>
      </div>
      <div class="content-item content-padding">
        <div class="item-title">
          <div class="title-text">2、生产商信息</div>
        </div>
        <div class="item-details">
          <!-- <div class="details-item container-half">
            <label class="details-label">生产商信息:</label>
            <div class="details-value">{{ gpsrManufacturerInfoVO.name }}</div>
          </div> -->
          <!-- <div class="details-item container-half">
            <label class="details-label"></label>
            <div class="details-value"></div>
          </div> -->
          <div class="details-item container-half">
            <label class="details-label">Manufacturer:</label>
            <div class="details-value">{{ gpsrManufacturerInfoVO.manufacturer }}</div>
          </div>
          <div class="details-item container-half">
            <label class="details-label">Address:</label>
            <div class="details-value">{{ gpsrManufacturerInfoVO.address }}</div>
          </div>
          <div class="details-item container-half">
            <label class="details-label">e-mail:</label>
            <div class="details-value">{{ gpsrManufacturerInfoVO.eMail }}</div>
          </div>
        </div>
      </div>
      <div class="content-item content-padding container-half content-inline">
        <div class="item-title">
          <div class="title-text">3、欧代信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-full">
            <label class="details-label">欧代信息:</label>
            <div class="details-value">{{ gpsrEuropeAgentInfoVO.europeAgentName }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">Name:</label>
            <div class="details-value">{{ gpsrEuropeAgentInfoVO.name }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">Address:</label>
            <div class="details-value">{{ gpsrEuropeAgentInfoVO.address }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">e-mail:</label>
            <div class="details-value">{{ gpsrEuropeAgentInfoVO.eMail }}</div>
          </div>
        </div>
        <div class="item-label-tip">
          <div class="label-tip-item">EU</div>
          <div class="label-tip-item">REP</div>
        </div>
      </div>
      <div class="content-item content-padding container-half content-inline">
        <div class="item-title">
          <div class="title-text">4、英代信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-full">
            <label class="details-label">英代信息:</label>
            <div class="details-value">{{ gpsrBritainAgentInfoVO.britainAgentName }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">Name:</label>
            <div class="details-value">{{ gpsrBritainAgentInfoVO.name }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">Address:</label>
            <div class="details-value">{{ gpsrBritainAgentInfoVO.address }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">e-mail:</label>
            <div class="details-value">{{ gpsrBritainAgentInfoVO.eMail }}</div>
          </div>
        </div>
        <div class="item-label-tip">
          <div class="label-tip-item">UK</div>
          <div class="label-tip-item">REP</div>
        </div>
      </div>
      <div class="content-item content-padding">
        <div class="item-title">
          <div class="title-text">5、安全警告信息</div>
        </div>
        <div class="item-details">
          <div class="details-item container-full">
            <label class="details-label">安全警告信息：</label>
            <div class="details-value">{{ gpsrSecurityWarningInfoVO.name }}</div>
          </div>
          <div class="details-item container-full">
            <label class="details-label">WARNING：</label>
            <div class="details-value style-pre-wrap">{{ gpsrSecurityWarningInfoVO.warning }}</div>
          </div>
        </div>
      </div>
      <div class="content-item content-padding">
        <div class="item-title">
          <div class="title-text">6、安全/环保/认证标识</div>
        </div>
        <div class="item-details">
          <div class="details-item container-full not-vertical-center">
            <label class="details-label">安全/环保/认证标识：</label>
            <div class="details-value">
              <div>{{ gpsrIdentificationInfoVO.name }}</div>
              <div class="details-img-list">
                <img
                  v-for="(item, index) in (gpsrIdentificationInfoVO.identificationData || [])"
                  :src="item.path"
                  :alt="item.name"
                  :title="item.name"
                  :key="`${item.path}-${index}`"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- GPSR填写模板管理 -->
    <Modal v-model="templateModalVisible" title="GPSR填写模板管理" :mask-closable="false" width="80vw">
      <gpsrTemplateView
        v-if="templateModalVisible"
        :module-data="templateModalData"
      />
      <div slot="footer">
        <Button @click="templateModalVisible = false">取消</Button>
      </div>
    </Modal>
    <!-- 编辑GPSR标签资料 -->
    <Modal v-model="editModalVisible" :title="editModalData.title" :mask-closable="false" width="80vw">
      <gpsrEditView
        ref="gpsrEditViewRef"
        v-if="editModalVisible"
        :module-data="editModalData"
      />
      <div slot="footer">
        <Button type="primary" @click="editModalConfirm" :disabled="editModalLoading">确定</Button>
        <Button @click="editModalVisible = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import gpsrTemplateView from './gpsrTemplateView';
import gpsrEditView from './gpsrEditView';
import api from '@/api/api';

export default {
  name: "gpsrView",
  components: {
    gpsrTemplateView,
    gpsrEditView
  },
  props: {
    moduleData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      pageLoading: true,
      templateModalVisible: false,
      editModalVisible: false,
      editModalLoading: false,
      templateModalData: {},
      editModalData: {},
      iconDataList: [],
      pageDetails: {}
    };
  },
  watch: {},
  computed: {
    productId () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.productId)) return '';
      return this.moduleData.productId;
    },
    productInfo () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.productInfo)) return {};
      return this.moduleData.productInfo;
    },
    productGoodsListDictionary () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.productGoodsListDictionary)) return {};
      return this.moduleData.productGoodsListDictionary;
    },
    // 权限
    permission () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.permission)) return {};
      return this.moduleData.permission;
    },
    // 生产商信息
    gpsrManufacturerInfoVO () {
      if (this.$common.isEmpty(this.pageDetails) || this.$common.isEmpty(this.pageDetails.gpsrManufacturerInfoVO)) return {};
      return this.pageDetails.gpsrManufacturerInfoVO;
    },
    // 欧代信息
    gpsrEuropeAgentInfoVO () {
      if (this.$common.isEmpty(this.pageDetails) || this.$common.isEmpty(this.pageDetails.gpsrEuropeAgentInfoVO)) return {};
      return this.pageDetails.gpsrEuropeAgentInfoVO;
    },
    // 英代信息
    gpsrBritainAgentInfoVO () {
      if (this.$common.isEmpty(this.pageDetails) || this.$common.isEmpty(this.pageDetails.gpsrBritainAgentInfoVO)) return {};
      return this.pageDetails.gpsrBritainAgentInfoVO;
    },
    // 安全警告信息
    gpsrSecurityWarningInfoVO () {
      if (this.$common.isEmpty(this.pageDetails) || this.$common.isEmpty(this.pageDetails.gpsrSecurityWarningInfoVO)) return {};
      return this.pageDetails.gpsrSecurityWarningInfoVO;
    },
    // 标识信息
    gpsrIdentificationInfoVO () {
      if (this.$common.isEmpty(this.pageDetails) || this.$common.isEmpty(this.pageDetails.gpsrIdentificationInfoVO)) return {};
      return this.pageDetails.gpsrIdentificationInfoVO;
    },
  },
  created() {
    this.pageLoading = true;
  },
  mounted () {
    this.$nextTick(() => {
      this.initPage().finally(() => {
        this.pageLoading = false;
      });
    })
  },
  methods: {
    // 初始化数据
    initPage () {
      return new Promise((resolve) => {
        let awaitRes = [this.getIconList];
        this.$common.promiseAll(awaitRes).finally(() => {
          this.$common.promiseAll([this.getDetails]).finally(() => {
            resolve({ state: 'end' });
          })
        });
      })
    },
    // 详情
    getDetails () {
      return new Promise((resolve) => {
        this.pageDetails = {};
        this.axios.get(api.queryProductGpsr, {
          params: {
            productId: this.productId
          }
        }).then(res => {
          if (!res || !res.data || res.data.code != 0) return resolve({ state: 'finally' });
          this.pageDetails = res.data.datas || {};
          if (this.pageDetails.gpsrIdentificationInfoVO && this.pageDetails.gpsrIdentificationInfoVO.identificationType) {
            const typeList = this.pageDetails.gpsrIdentificationInfoVO.identificationType.split(',');
            let newTypeInfo = [];
            this.iconDataList.forEach(item => {
              if (typeList.includes(item.identificationType)) {
                newTypeInfo.push(item);
              }
            });
            if (this.$common.isUndefined(this.pageDetails.gpsrManufacturerInfoVO) || this.pageDetails.gpsrManufacturerInfoVO == null) {
              this.pageDetails.gpsrManufacturerInfoVO = {};
            }
            this.pageDetails.gpsrManufacturerInfoVO.manufacturer = this.pageDetails.manufacturer;
            this.pageDetails.gpsrManufacturerInfoVO.address = this.pageDetails.address;
            this.pageDetails.gpsrManufacturerInfoVO.eMail = this.pageDetails.eMail;

            this.pageDetails.gpsrIdentificationInfoVO.identificationData = newTypeInfo;
          }
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取认证标识
    getIconList () {
      return new Promise((resolve) => {
        this.iconDataList = [];
        this.axios.get(api.identificationInfo).then(res => {
          if (!res || !res.data || res.data.code != 0) return resolve({ state: 'finally' });
          this.iconDataList = (res.data.datas || []).map(m => {
            return {
              ...m,
              path: `/product-service/filenode/s${m.path}`,
              identificationType: (m.identificationType).toString(),
            }
          }).sort((a, b) => {
            return a.sort - b.sort;
          });
          // console.log(this.iconDataList)
          resolve({ state: 'finally' });
        }).catch(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 打开模板编辑弹窗
    openTemplateModal () {
      this.templateModalData = {
        permission: this.permission,
        iconDataList: this.iconDataList
      };
      this.$nextTick(() => {
        this.templateModalVisible = true;
      })
    },
    // 打开编辑弹窗
    openEditModal () {
      this.editModalData = {
        title: '编辑GPSR标签资料',
        permission: this.permission,
        data: this.pageDetails,
        productInfo: this.productInfo,
        productGoodsListDictionary: this.productGoodsListDictionary,
        iconDataList: this.iconDataList
      };
      this.$nextTick(() => {
        this.editModalVisible = true;
      })
    },
    // 删除 GPSR 资料
    delGpsrInfo () {
      this.$Modal.confirm({
        title: '操作提示',
        okText: '确定',
        content: `<div>确认删除GPSR资料，SPU：<span style="color: #f20;">${this.productInfo.spu}</span></div>`,
        onOk: () => {
          this.pageLoading = true;
          this.axios.post(`${api.gpsrDelete}?productId=${this.productId}`).then(res => {
            this.pageLoading = false;
            if (!res || !res.data || res.data.code != 0) return;
            this.$Message.success('操作成功！');
            this.pageDetails = {};
            this.$emit('refreshList', 'sku');
          }).catch(() => {
            this.pageLoading = false;
          })
        }
      })
    },
    // 编辑保存
    editModalConfirm () {
      if (this.editModalLoading) return;
      if (this.$refs.gpsrEditViewRef) {
        this.editModalLoading = true;
        this.$refs.gpsrEditViewRef.saveFormData({
          saveApi: api.gpsrUpdate,
          method: 'put',
        }).then((res) => {
          if (res.state != 'success') return;
          this.editModalVisible = false;
          this.$Message.success('操作成功！');
          this.pageLoading = true;
          this.$emit('refreshList', 'sku');
          this.getDetails().finally(() => {
            this.pageLoading = false;
          });
        }).finally(() => {
          this.editModalLoading = false;
        })
      }
    }
  }
};
</script>
<style lang="less" scoped>
.gpsr-info-view {
  position: relative;
  margin: 15px 10px 10px 10px;
  max-height: calc(100% - 25px);
  font-size: 14px;
  overflow: auto;
  .head-btn{
    padding: 0 100px 0 30px;
    text-align: right;
  }
  .text-underline{
    cursor: pointer;
    text-decoration: underline;
    text-underline-position: under;
    color: #0000ff;
    &.error{
      color: #f20;
    }
  }
  .content-padding {
    padding: 0 10px;
  }
  .content-item{
    .item-title{
      position: relative;
      &:before {
        position: absolute;
        content: '';
        height: 100%;
        width: 4px;
        background: #2d8cf0;
      }
      .title-text{
        padding-left: 10px;
      }
    }
    .item-details{
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
    }
  }
  .not-gpsr-warning{
    padding-top: 15px;
    width: 80%;
    max-width: 850px;
    min-width: 500px;
    border: 1px solid #ffcc00;
    background: #fffbe6;
    .not-gpsr-icon{
      font-size: 25px;
      color: #ffcc00;
      vertical-align: middle;
    }
  }
  .details-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    &.container-full{
      &:nth-of-type(2n-1) {
        padding-right: 0;
      }
      &:nth-of-type(2n) {
        padding-left: 0;
      }
    }
    .details-label{
      width: 220px;
      line-height: 1.2em;
      text-align: right;
      word-wrap: break-word;
      word-break: break-word;
    }
    .details-value {
      padding-left: 5px;
      flex: 100;
      line-height: 1.2em;
      text-align: left;
      word-wrap: break-word;
      word-break: break-word;
    }
    &:nth-of-type(2n-1) {
      padding-right: 10px;
    }
    &:nth-of-type(2n) {
      padding-left: 10px;
    }
    &.not-vertical-center{
      align-items: initial;
    }
  }
  .details-img-list{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    margin-top: 5px;
    img {
      // flex: 100;
      margin: 0px 10px 10px 0px;
      max-height: 74px;
      padding: 2px 5px;
      border: 1px solid #ccc;
      object-fit: contain;
    }
  }
  .container-full {
    width: 100%;
  }
  .container-half{
    width: 50%;
  }
  .content-inline{
    position: relative;
    display: inline-block;
  }
  .li-style-initial{
    margin-left: calc(1em + 1px);
    li {
      list-style: initial;
    }
  }
  .item-label-tip{
    position: absolute;
    bottom: 37px;
    left: 50px;
    display: flex;
    border: 4px solid #333;
    .label-tip-item{
      padding: 6px 10px;
      border-right: 4px solid #333;
      font-weight: bold;
      &:last-child{
        border-right: none;
      }
    }
  }
  .style-pre-wrap{
    white-space: pre-wrap;
  }
}
</style>
